/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const changeSku = createAsyncThunk(
  'products/changeSku',
  async ({ productId, variantId = 'default', sku }, {
    extra: {
      sdk, Logger, showErrorDialog, utils,
    },
  }) => {
    try {
      const { data } = await sdk.products.changeSku(productId, variantId, sku);
      return data;
    } catch (error) {
      const errorMessage = utils.getDataFromResponceError(error, 'msg') || 'Can not change product sku';
      showErrorDialog(errorMessage);
      Logger.error(new Error('Error product change sku'), { error }, [
        'ChangeSkuProductFailed',
        { errorMessage: errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(
      changeSku.pending,
      (state, { meta }) => {
        const { productId } = meta.arg;
        state.items.forEach((product) => {
          if (product._id === productId) {
            product.isBusy = true;
          }
        });
      },
    )
    .addCase(
      changeSku.fulfilled,
      (state, { meta, payload }) => {
        const { productId } = meta.arg;
        state.items.forEach((product) => {
          if (product._id === productId) {
            product.isBusy = false;
            product.variants = payload.variants;
            product.defaultVariant = payload.defaultVariant;
          }
        });
      },
    )
    .addCase(
      changeSku.rejected,
      (state, { meta, error }) => {
        state.items.forEach((product) => {
          if (product._id === meta.arg.productId) {
            product.isBusy = false;
          }
        });
        state.error = error;
      },
    );
};
